import type { TemplateBlockInstance } from '@/templates/domain/types';

/** The block kinds that print flowing text or pictures, and so may start on a page of their own. */
const PAGE_BREAK_KINDS: ReadonlySet<unknown> = new Set(['custom_text', 'custom', 'terms_conditions', 'scope_of_work', 'comments']);

/** A free-text or Custom block flagged `pageBreakBefore` starts a new page, in the preview and in the PDF. */
export function startsOnNewPage(instance: TemplateBlockInstance): boolean {
  const content = (instance.importedBlockJson as { content?: { kind?: unknown; pageBreakBefore?: unknown } } | null)?.content;
  return PAGE_BREAK_KINDS.has(content?.kind) && content?.pageBreakBefore === true;
}
